// なりすましバーの事業者切替メニューの絞り込み (manage / shops の両 pack から読む)

// 事業者名は全角英数で登録されていることがあるため、全角半角を揃えてから比べる
const normalizeForSearch = (text) => text.normalize('NFKC').toLowerCase();

function setupSwitcherFilter() {
  const switcher = document.getElementById('proxy_login_list');
  if (!switcher) return;

  const filter = switcher.querySelector('[data-switcher-filter]');
  const empty = switcher.querySelector('[data-switcher-empty]');
  const items = Array.from(switcher.querySelectorAll('[data-switcher-item]'));
  if (!filter || !empty || items.length === 0) return;

  // 絞り込みは JS でしか効かないので、ここまで来てから出す
  filter.hidden = false;

  const entries = items.map((item) => ({
    item,
    name: normalizeForSearch(item.dataset.switcherItem),
  }));

  filter.addEventListener('input', () => {
    const keyword = normalizeForSearch(filter.value.trim());
    const matched = entries.filter(({ item, name }) => {
      const hit = name.includes(keyword);
      item.hidden = !hit;
      return hit;
    });
    empty.hidden = matched.length > 0;
  });

  switcher.addEventListener('toggle', () => {
    // 狭い画面でフォーカスするとソフトキーボードが一覧を覆うので、広い画面だけにする
    // (768px = _admin_proxy_login.scss で位置を切り替えるのと同じ境界)
    if (switcher.open && window.matchMedia('(min-width: 768px)').matches) {
      filter.focus();
    }
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', setupSwitcherFilter);
} else {
  setupSwitcherFilter();
}
